import { createApp } from "vue";
import { i18n } from "i18n";
import vui from "vui";
import App from "App";

const el = document.getElementById("navigation");

const app = createApp(App, {
	authEmail: el.dataset.authEmail,
	rightItems: JSON.parse(el.dataset.rightItems) ? JSON.parse(el.dataset.rightItems) : [],
	locale: el.dataset.locale,
	locales: JSON.parse(el.dataset.locales)
});

app.use(i18n);
app.use(vui);

app.mount(el);
